import { render, staticRenderFns } from "./vacancyRate.vue?vue&type=template&id=2f3db8c7&"
import script from "./vacancyRate.vue?vue&type=script&lang=js&"
export * from "./vacancyRate.vue?vue&type=script&lang=js&"
import style0 from "./vacancyRate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports